export default "__VITE_ASSET__Ml7rR5wV__"